import React from "react";

interface KnootLogoProps {
  className?: string;
  style?: React.CSSProperties;
  color?: string;
  boxSize?: string | number;
}

export const KnootLogo: React.FC<KnootLogoProps> = ({
  color = "primary.500",
  className,
  style,
  boxSize = "1317",
  ...props
}) => {
  return (
    <svg
      width={boxSize}
      height={boxSize}
      viewBox="0 0 1317 1317"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <rect width="1317" height="1317" rx="234" fill="#FFCB59" />
      <path
        d="M104.21 950.713V1018.56C104.21 1018.56 280.32 1037.26 438.599 871.994L375.299 838.449C251.961 957.031 104.21 950.713 104.21 950.713Z"
        fill="#FFF9E9"
      />
      <path
        d="M628.381 247.21C628.381 247.21 523.51 561.726 515.532 585.095C504.634 617.018 475.269 692.027 445.572 750.327C430.611 774.828 414.479 796.332 397.663 815.218C418.59 826.624 448.492 836.243 465.923 841.341C483.511 820.16 500.727 796.498 517.29 770.024C589.945 642.526 608.343 530.262 657.912 387.53C683.224 309.836 696.935 269.758 696.935 269.758L628.381 247.21Z"
        fill="#FFF9E9"
      />
      <path
        d="M1211.61 365.724L1167.32 314.045C963.767 450.097 685.334 490.175 663.186 493.339C661.819 493.534 660.1 493.739 658.059 493.954C638.431 563.816 633.88 571.521 633.323 572.273C987.155 541.287 1211.61 365.724 1211.61 365.724Z"
        fill="#FFF9E9"
      />
      <path
        d="M514.712 782.123C509.858 781.142 509.533 781.237 504.946 780.17C374.814 749.881 351.395 685.826 380.534 633.209C411.119 577.965 464.908 573.493 500.766 574.548C535.844 575.583 544.691 578.63 599.359 574.811L623.089 496.717C578.216 499.685 510.6 502.83 478.618 502.83C433.267 502.83 326.746 522.869 307.762 614.625C288.778 706.381 306.707 799.192 474.4 843.489C642.092 887.785 850.917 1069.19 850.917 1069.19L894.158 1014.35C731.602 860.764 562.152 799.242 528.383 785.541C523.989 784.076 520.571 783.307 514.712 782.123Z"
        fill="#FFF9E9"
      />
    </svg>
  );
};
